import {Component} from '@angular/core';

import {GlobalSpinnerService} from './global-spinner.service';
import {AsyncPipe, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'vi-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
  imports: [
    AsyncPipe,
    TranslateModule,
    MatProgressSpinner,
    NgIf
  ],
  standalone: true
})
export class GlobalSpinnerComponent {
  constructor(public globalSpinnerService: GlobalSpinnerService) {
  }
}
